module.exports = __webpack_public_path__ + "images/warningIcon-18c0bfbc51119d253f92de954fd3e00c.svg";